<div class="">
	<div class="ant-alert ant-alert-with-description p-20 custom-size"
		[ngClass]="type == 'error' ? 'ant-alert-error' : 'ant-alert-info'">
		<i class="anticon ant-alert-icon anticon-close-circle">
			<svg width="36" height="36" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
				<circle opacity="0.1" cx="24.5" cy="24.5" r="24.5" fill="#0361F0" />
				<path
					d="M30.7345 12.1666H19.555C18.7145 12.1666 18 12.8391 18 13.7217V30.1546C18 30.9951 18.7145 31.7096 19.555 31.7096H30.7765C31.617 31.7096 32.3315 30.9951 32.3315 30.1546V13.7217C32.2895 12.8391 31.617 12.1666 30.7345 12.1666ZM22.2868 29.7343H19.9333V27.717H22.2868V29.7343ZM22.2868 25.8677H19.9333V23.8084H22.2868V25.8677ZM22.2868 21.9591H19.9333V19.8998H22.2868V21.9591ZM26.3215 29.7343H23.968V27.717H26.3215V29.7343ZM26.3215 25.8677H23.968V23.8084H26.3215V25.8677ZM26.3215 21.9591H23.968V19.8998H26.3215V21.9591ZM30.3562 29.7343H28.0026V27.717H30.3562V29.7343ZM30.3562 25.8677H28.0026V23.8084H30.3562V25.8677ZM30.3562 21.9591H28.0026V19.8998H30.3562V21.9591ZM30.3562 17.8404H19.9333V14.0999H30.3562V17.8404Z"
					fill="#0361F0" />
				<path
					d="M24.8517 32.298V38.6442H28.5501C29.5168 38.6442 30.3153 37.8457 30.3153 36.879V32.298H24.8517ZM20.1445 32.298V36.837C20.1445 37.8457 20.9431 38.6442 21.9517 38.6442H22.33V32.298H20.1445ZM22.9184 32.298V38.6442H24.2212V32.298H22.9184Z"
					fill="#0361F0" />
				<path
					d="M24.8517 32.298V38.6442H28.5501C29.5168 38.6442 30.3153 37.8457 30.3153 36.879V32.298H24.8517ZM20.1445 32.298V36.837C20.1445 37.8457 20.9431 38.6442 21.9517 38.6442H22.33V32.298H20.1445ZM22.9184 32.298V38.6442H24.2212V32.298H22.9184Z"
					fill="#0361F0" />
			</svg>
		</i>
		<div class="ant-alert-content">
			<span class="ant-alert-message name">
				{{terminalInfo.terminalId}}
			</span>
			<span class="ant-alert-description">
				<span class="display-block bank-detail">{{terminalInfo.serialNo || terminalInfo.serialNumber}}</span>
			</span>
		</div>
	</div>

</div>
